export default __webpack_public_path__ + "static/media/nozzle.578b700c.svg";